import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Grid, Typography } from "@mui/material"

import { ImageSkuBlock, MoreLessInfo, MultimediaRow, PlaceholderVideoImg } from "@components"
import { multimediaCarouselImages, multimediaCarouselVideos } from "@signals"
import { isModalVideo } from "../../@signals"


const ImagesBlockContainer = ({ img }) => <ImageSkuBlock hideName imageURL={img} isClickable={false} />

export default function AdminScrapingDataReviewDetailsDrawerContentTabDescription(props) {
    const { images, videos, giftImages, giftText, description, richContent, richContentImages, richContentVideos, richContentText } = props

    return <Box display="flex" flexDirection="column" gap={2}>

        <MultimediaRow
            title="Images: "
            multimedia={images}
            handleClick={value => multimediaCarouselImages.value = value}
            Container={({ item }) => <ImagesBlockContainer img={item} />}
        />

        <MultimediaRow
            title="Videos: "
            multimedia={videos}
            handleClick={value => batch(() => {
                multimediaCarouselVideos.value = value
                isModalVideo.value = true
            })}
            Container={() => <PlaceholderVideoImg />}
        />

        { giftText?.length > 0 && <Grid item xs={12}>
            <MoreLessInfo moreText="Show more gift text..." lessText="Show less gift text...">
                {giftText}
            </MoreLessInfo>
        </Grid> }

        <MultimediaRow
            title="Gift Images: "
            multimedia={giftImages}
            handleClick={value => multimediaCarouselImages.value = value}
            Container={({ item }) => <ImagesBlockContainer img={item} />}
        />

        <Grid item xs={12}>
            <MoreLessInfo>
                {description}
            </MoreLessInfo>
        </Grid>

        <Grid item xs={12}>
            <Typography variant="subtitle2">
                Rich Content: { !richContent && "--" }
            </Typography>

            { !!richContent && <MoreLessInfo moreText="Show more rich content..." lessText="Show less rich content...">
                <MultimediaRow
                    title="Images: "
                    multimedia={richContentImages}
                    handleClick={value => multimediaCarouselImages.value = value}
                    Container={({ item }) => <ImagesBlockContainer img={item} />}
                />

                <MultimediaRow
                    title="Videos: "
                    multimedia={richContentVideos}
                    handleClick={value => batch(() => {
                        multimediaCarouselVideos.value = value
                        isModalVideo.value = true
                    })}
                    Container={() => <PlaceholderVideoImg />}
                />

                <Typography variant="subtitle2">
                    Content:
                </Typography>

                <Typography>
                    {richContentText}
                </Typography>
            </MoreLessInfo> }
        </Grid>
    </Box>
}